export default __webpack_public_path__ + "static/media/BMWGroupSerif-Regular.2cec5f36.woff2";